<sb-dialog-header>
  <h3 sb-dialog-title>
    {{ 'Labs' | translate }}
  </h3>
</sb-dialog-header>

<sb-dialog-content class="flex flex-col gap-lg">
  <div sbSurface class="flex items-center justify-between">
    <span class="text-lg text-default">{{ 'All Labs features' | translate }}</span>
    <div (click)="optInToggle()" class="cursor-pointer">
      <sb-switch [checked]="userPreferencesStore.labs_enabled()" class="pointer-events-none" />
    </div>
  </div>

  <span class="font-medium text-support">{{
    'Use the latest cutting edge features by Shiftbase and help improve the product for your business and others. Settings apply across web and mobile.'
      | translate
  }}</span>

  <div class="flex flex-col gap-md">
    @for (labsItem of visibleLabsItems; track labsItem.featureFlag) {
      <sb-info-card
        [title]="labsItem.title | translate"
        [icon]="labsItem.icon"
        [linkLabel]="'Give feedback' | translate"
        (linkClick)="openFeedbackSurvey(labsItem.surveyId)"
      >
        {{ labsItem.description | translate }}
      </sb-info-card>
    }
  </div>
</sb-dialog-content>
